import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=6bda6ecd&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bda6ecd')) {
      api.createRecord('6bda6ecd', component.options)
    } else {
      api.reload('6bda6ecd', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=6bda6ecd&", function () {
      api.rerender('6bda6ecd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2M3lAfT4xBSux/JS/comp/openstreetmap.vue"
export default component.exports